import D from './contact-channels181.js';

var n=new RegExp("(?:"+D()+")$","i");function c(e){var a=e.search(n);if(a<0)return {};for(var i=e.slice(0,a),r=e.match(n),t=1;t<r.length;){if(r[t])return {number:i,ext:r[t]};t++;}}

export { c as default };
//# sourceMappingURL=contact-channels186.js.map
